module.exports = __webpack_public_path__ + "media/houses-illustration.f9aca855.svg";